import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-notes-history',
  templateUrl: './notes-history.component.html',
  styleUrl: './notes-history.component.scss',
})
export class NotesHistoryComponent implements OnInit {
  lists: any;

  @Input()
  Heading: any;
  @Input()
  notesHistory: any;
  
  notesDetails: any;
  notesArray: any[] = [];

  constructor(
    public bsModalRef: BsModalRef,
    private domSanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    if (this.notesHistory) {
      this.notesDetails = this.notesHistory
      console.log(this.notesDetails, 'notesDetails')
      let decoded = this.decodeHtmlEntities(this.notesDetails);
      this.notesDetails = this.domSanitizer.bypassSecurityTrustHtml(decoded);
      
      // Parse the HTML to create structured notes array
      this.parseNotesHistory(decoded);
    }
  }

  parseNotesHistory(htmlString: string): void {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    
    // Find all elements with class 'Noteshistory' (note headers)
    const noteHeaders = doc.querySelectorAll('.Noteshistory');
    
    noteHeaders.forEach((header, index) => {
      let content = '';
      let nextElement = header.nextElementSibling;
      
      // Collect all content until the next header or end
      while (nextElement && !nextElement.classList.contains('Noteshistory')) {
        if (nextElement.classList.contains('NotesPre')) {
          content += nextElement.innerHTML;
        }
        nextElement = nextElement.nextElementSibling;
      }
      
      // Extract user info and timestamp from header
      const headerText = header.textContent || '';
      const match = headerText.match(/(.*?)\s+(\d{1,2}\/\d{1,2}\/\d{4})\s+(\d{1,2}:\d{2}\s+[AP]M)/);
      
      let userName = headerText;
      let date = '';
      let time = '';
      
      if (match) {
        userName = match[1].trim();
        date = match[2];
        time = match[3];
      }
      
      this.notesArray.push({
        id: index,
        userName: userName,
        date: date,
        time: time,
        content: content,
        isExpanded: false
      });
    });
    
    console.log('Parsed notes array:', this.notesArray);
  }

  toggleNote(note: any): void {
    note.isExpanded = !note.isExpanded;
  }

  closeTaskSelectionMenu() {
    this.bsModalRef.hide();
  }

  decodeHtml(html: string): string {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }

  decodeHtmlEntities(encoded: string): string {
    const entityMap: { [key: string]: string } = {
      '&amp;': '&',
      '&lt;': '<',
      '&gt;': '>',
      '&quot;': '"',
      '&#39;': "'",
      '&#x2F;': '/',
      '&#x5C;': '\\',
      '&#96;': '`'
    };

    let decoded = encoded;

    // Decode repeatedly in case of nested encodings
    let prev;
    do {
      prev = decoded;
      for (const [entity, char] of Object.entries(entityMap)) {
        decoded = decoded.replace(new RegExp(entity, 'g'), char);
      }
    } while (decoded !== prev);
    //decoded = decoded.replace(/<span class="NotesPre">(.*?)<\/>/gi, '');
    return decoded;
  }
}
